import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";

const Services = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeService, setActiveService] = useState(null);

    const services = [
        {
            id: 1,
            title: "Üstyapı Projeleri",
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            ),
            description: "Modern mimari ve yenilikçi çözümlerle konut, ofis ve ticari yapılar inşa ediyoruz.",
            features: [
                "Konut Projeleri",
                "Ticari Yapılar",
                "Ofis Binaları",
                "Alışveriş Merkezleri",
                "Otel ve Turizm Tesisleri",
                "Endüstriyel Yapılar"
            ],
            stats: {
                projects: "150+",
                area: "2M+ m²",
                experience: "8 Yıl"
            }
        },
        {
            id: 2,
            title: "Altyapı Projeleri",
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            ),
            description: "Şehirlerin temel altyapı ihtiyaçlarını modern teknolojilerle karşılıyoruz.",
            features: [
                "Karayolu İnşaatı",
                "Köprü ve Viyadük",
                "Su ve Kanalizasyon Sistemleri",
                "Metro ve Raylı Sistemler",
                "Enerji Tesisleri",
                "Havalimanı Altyapısı"
            ],
            stats: {
                projects: "80+",
                area: "500+ km",
                experience: "8 Yıl"
            }
        },
        {
            id: 3,
            title: "Kentsel Dönüşüm",
            icon: (
                <svg className="w-full h-full" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
            ),
            description: "Şehirleri yeniden planlıyor, yaşam alanlarını modern standartlara taşıyoruz.",
            features: [
                "Kentsel Dönüşüm Projeleri",
                "Yenileme ve Restorasyon",
                "Çevre Düzenlemesi",
                "Sosyal Donatı Alanları",
                "Peyzaj Tasarımı",
                "Akıllı Şehir Çözümleri"
            ],
            stats: {
                projects: "45+",
                area: "800+ Konut",
                experience: "8 Yıl"
            }
        }
    ];

    const process = [
        {
            step: "01",
            title: "Planlama & Tasarım",
            description: "Projenizi detaylı şekilde analiz ediyor, ihtiyaçlarınıza özel çözümler üretiyoruz.",
            icon: (
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            )
        },
        {
            step: "02",
            title: "Ruhsat & İzinler",
            description: "Tüm yasal süreçleri ve izinleri hızlı ve eksiksiz şekilde tamamlıyoruz.",
            icon: (
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            )
        },
        {
            step: "03",
            title: "İnşaat & Uygulama",
            description: "Deneyimli ekibimiz ve modern ekipmanlarımızla projeyi hayata geçiriyoruz.",
            icon: (
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                </svg>
            )
        },
        {
            step: "04",
            title: "Kontrol & Teslim",
            description: "Kalite kontrollerini yapıyor, projeyi güvenle teslim ediyoruz.",
            icon: (
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            )
        }
    ];

    return (
        <div className="min-h-screen bg-white">
            {/* Logo */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
        
            {/* Navbar */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        <button 
                            className="md:hidden text-white p-14"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            {/* Hero Section */}
            <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f]">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                </div>

                <div className="absolute inset-0 opacity-5" style={{
                    backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                    backgroundSize: '50px 50px'
                }}></div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10 text-center py-24 md:py-32">
                    <div className="inline-flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-white/20 backdrop-blur-md rounded-full mb-6 md:mb-8 animate-fade-in-down">
                        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                        <span className="text-white text-xs md:text-sm font-semibold tracking-wider">HİZMETLERİMİZ</span>
                    </div>
                    
                    <h1 className="font-display text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight animate-fade-in" style={{ animationDelay: '0.2s' }}>
                        Geleceği İnşa Eden<br />
                        <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">Çözümlerimiz</span>
                    </h1>
                    
                    <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed animate-fade-in px-4" style={{ animationDelay: '0.4s' }}>
                        Üstyapıdan altyapıya, kentsel dönüşümden özel projelere kadar geniş yelpazede profesyonel hizmetler sunuyoruz.
                    </p>

                    {/* Scroll Indicator */}
                    <div className="animate-bounce mt-12 md:mt-16">
                        <svg className="w-6 h-6 text-white/70 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="py-16 md:py-20 lg:py-32 bg-white">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                    <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
                        {services.map((service, idx) => (
                            <div 
                                key={service.id}
                                className="group relative bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                                style={{ animationDelay: `${idx * 0.1}s` }}
                            >
                                {/* Icon */}
                                <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-xl md:rounded-2xl flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-500 text-white p-3 md:p-4">
                                    {service.icon}
                                </div>

                                {/* Title */}
                                <h3 className="font-display text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-3 md:mb-4">
                                    {service.title}
                                </h3>

                                {/* Description */}
                                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4 md:mb-6">
                                    {service.description}
                                </p>

                                {/* Features */}
                                <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
                                    {service.features.map((feature, featureIdx) => (
                                        <li key={featureIdx} className="flex items-start gap-2 md:gap-3 text-gray-700">
                                            <svg className="w-4 h-4 md:w-5 md:h-5 text-[#01346b] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                            </svg>
                                            <span className="text-xs md:text-sm lg:text-base">{feature}</span>
                                        </li>
                                    ))}
                                </ul>

                                {/* Stats */}
                                <div className="pt-4 md:pt-6 border-t border-gray-200 grid grid-cols-3 gap-3 md:gap-4">
                                    <div className="text-center">
                                        <div className="font-bold text-[#01346b] text-lg md:text-xl">{service.stats.projects}</div>
                                        <div className="text-gray-500 text-[10px] md:text-xs">Proje</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="font-bold text-[#01346b] text-lg md:text-xl">{service.stats.area}</div>
                                        <div className="text-gray-500 text-[10px] md:text-xs">Alan</div>
                                    </div>
                                    <div className="text-center">
                                        <div className="font-bold text-[#01346b] text-lg md:text-xl">{service.stats.experience}</div>
                                        <div className="text-gray-500 text-[10px] md:text-xs">Tecrübe</div>
                                    </div>
                                </div>

                                {/* Hover Effect Border */}
                                <div className="absolute inset-0 rounded-2xl md:rounded-3xl border-2 border-[#01346b] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="py-16 md:py-20 lg:py-32 bg-[#f8f9fa]">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="text-center mb-12 md:mb-16">
                        <div className="inline-flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-[#01346b]/10 rounded-full mb-4 md:mb-6">
                            <span className="text-[#01346b] text-xs md:text-sm font-semibold tracking-wider">ÇALIŞMA SÜRECİMİZ</span>
                        </div>
                        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-4">
                            Nasıl Çalışıyoruz?
                        </h2>
                        <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-3xl mx-auto px-4">
                            Projenizi baştan sona profesyonel bir ekiple yönetiyor, her adımda sizinle birlikte ilerliyoruz.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                        {process.map((item, idx) => (
                            <div 
                                key={idx}
                                className="relative bg-white rounded-2xl md:rounded-3xl p-5 md:p-6 lg:p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group"
                            >
                                {/* Step Number */}
                                <div className="absolute -top-3 -left-3 md:-top-4 md:-left-4 w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-xl md:rounded-2xl flex items-center justify-center text-white font-bold text-base md:text-xl shadow-xl group-hover:scale-110 transition-transform duration-300">
                                    {item.step}
                                </div>

                                {/* Icon */}
                                <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#01346b]/10 to-[#024a8f]/10 rounded-lg md:rounded-xl flex items-center justify-center mb-3 md:mb-4 text-[#01346b] mt-6 md:mt-8">
                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                        {item.icon}
                                    </div>
                                </div>

                                {/* Content */}
                                <h3 className="font-display text-base md:text-lg lg:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                                    {item.title}
                                </h3>
                                <p className="text-gray-600 text-xs md:text-sm leading-relaxed">
                                    {item.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-16 md:py-20 lg:py-32 bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f] relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 text-center relative z-10">
                    <h2 className="font-display text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 md:mb-6 px-4">
                        Projenizi Görüşelim
                    </h2>
                    <p className="text-sm md:text-base lg:text-lg xl:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto px-4">
                        Size özel çözümler üretmek ve hayalinizdeki projeyi hayata geçirmek için buradayız.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4">
                        <Link to="/iletisim" className="px-6 md:px-8 py-3 md:py-4 bg-white text-[#01346b] rounded-full text-sm md:text-base font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:scale-105 flex items-center justify-center gap-2">
                            <span>İletişime Geç</span>
                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </Link>
                        <Link to="/projeler" className="px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-md text-white border-2 border-white/30 rounded-full text-sm md:text-base font-bold hover:bg-white/20 transition-all duration-300 flex items-center justify-center gap-2">
                            <span>Projelerimizi İncele</span>
                        </Link>
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fade-in-down {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in-down {
                    animation: fade-in-down 0.6s ease-out;
                }

                .animate-fade-in {
                    animation: fade-in 0.6s ease-out;
                }
            `}</style>
        </div>
    );
};

export default Services;
